var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKusama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.895 39.19v-.413a3.903 3.903 0 0 1-2.895.45l1.78-1.41H8.546l12.353-6.566-2.752-.028s10.688-6.99 13.38-8.677c2.693-1.688 4.386-2.158 5.046-2.628.66-.47 2.294-2.106 3.138-2.665l.025-.017c.843-.559 2.079-1.378 3.296-1.215a4.854 4.854 0 0 1 2.62 1.316C46.228 17.803 48 19.35 48 19.35s-2.321.898-2.83 1.297a5.408 5.408 0 0 0-1.652 2.35c-.399.988-1.123 3.089-1.605 4.137-.482 1.049-1.266 2.412-4.702 4.23-2.895 1.543-4.321 2.14-4.73 3.211a3.395 3.395 0 0 0 .46 3.244c.573.71 1.71 1.988 2.89 2.35 1.178.362 1.265.832 1.265.832a9.065 9.065 0 0 0-2.256-.371 9.18 9.18 0 0 0-2.505.371c0-.465.876-.832.876-.832s-.032-.62-1.72-1.763a3.99 3.99 0 0 1-1.21-1.262 4.098 4.098 0 0 1-.565-1.67s-2.803-.189-2.954-.189l1.729-.522c-2.867-1.541-17.596 4.428-17.596 4.428Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKusama);
export default __webpack_public_path__ + "static/media/kusama.d9a93a0fd9ff87e4de894486742039d4.svg";
export { ForwardRef as ReactComponent };